// Mode Agent autonome : configuration et clés de stockage dédiées.
// Le mode Classique n'utilise jamais ces clés, et ce module n'écrit jamais
// dans les clés du mode Classique.

/** Feature flag : REACT_APP_AUTONOMOUS_MODE=true dans le .env active le mode autonome. */
export const isAutonomousModeEnabled = (): boolean =>
    process.env.REACT_APP_AUTONOMOUS_MODE === 'true';

/**
 * REACT_APP_AUTONOMOUS_MOCK=true : le mode autonome tourne sur les mocks du navigateur
 * (développement sans backend). Par défaut, il appelle le backend Pegasux.
 */
export const isAutonomousMockApi = (): boolean =>
    process.env.REACT_APP_AUTONOMOUS_MOCK === 'true';

/** Préfixe des campagnes créées par le mode autonome (lots autonomous-<runId>-<n°>) */
export const AUTONOMOUS_CAMPAIGN_PREFIX = 'autonomous-';

/** Une notification de progression (WebSocket) concerne-t-elle un lot du mode autonome ? */
export const isAutonomousCampaignMessage = (data: unknown): boolean => {
    if (!data || typeof data !== 'object') return false;
    const { campaign_name: name, campaign_id: id } = data as { campaign_name?: unknown; campaign_id?: unknown };
    return [name, id].some((v) => typeof v === 'string' && v.startsWith(AUTONOMOUS_CAMPAIGN_PREFIX));
};

export const AUTONOMOUS_STORAGE_KEYS = {
    /** sessionStorage : mode choisi sur la première page */
    selectedMode: 'AUTONOMOUS_SELECTED_MODE',
    /** localStorage (mock) : état du run en cours */
    runState: 'AUTONOMOUS_RUN_STATE',
    /** localStorage (mock) : template et signature des emails du mode autonome */
    emailTemplate: 'AUTONOMOUS_EMAIL_TEMPLATE',
    /** localStorage (mock) : conditions d'éligibilité, indexées par slug de PV */
    eligibility: 'AUTONOMOUS_ELIGIBILITY',
    /** localStorage (mock) : réglages (persona Sales Navigator) */
    settings: 'AUTONOMOUS_SETTINGS',
    /** localStorage : dernières options de lancement choisies (confort, pas une donnée métier) */
    launchOptions: 'AUTONOMOUS_LAUNCH_OPTIONS',
} as const;

export const AUTONOMOUS_ROUTES = {
    template: '/agent/template',
    surfer: '/surfer',
    signals: '/agent/signaux',
    sources: '/agent/sources',
    assistant: '/agent/assistant',
} as const;

/** Intervalle de lecture de l'état du run pendant l'exécution */
export const RUN_POLL_INTERVAL_MS = 2000;
